var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: 'OrderDetails', query: { orderNumber: _vm.item.OrderNumber, orderSource: _vm.item.OrderSource, dealerCode: _vm.item.DealerCode, salesOrg: _vm.item.SalesOrg }}}},[_vm._v("\n  "+_vm._s(_vm.item.OrderNumber)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }